//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "CardCalendar",
  components: {},
  props: ["w", "h", "can-drag"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      schoolYear: "-",
      semester: 1,
      starttime: "-",
      endtime: "-",
      month: "-",
      showText: "",
      show: false,
      work: null,
      date: "-",
      list: [],
      serveId: "",
      scrollBar1: "scroll-bar1",
      scrollBar: "scroll-bar"
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.fetchList();
  },
  destroyed: function destroyed() {},
  methods: {
    clickItem: function clickItem(item) {
      if (!item.items || item.items && item.items.length == 0) {
        return;
      }

      var isVaca;

      switch (item.isvacation) {
        case "1":
          isVaca = "休息日";
          break;

        case "2":
          isVaca = "上班日";
          break;

        default:
          isVaca = "正常";
          break;
      }

      this.$alert("".concat(item.item), "".concat(this.month, "\u6708").concat(item.indexDate, "\u65E5 ( \u4F5C\u606F\uFF1A").concat(isVaca, " )"), {
        center: "true",
        confirmButtonText: "确定"
      });
    },
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      this.$http.post("/calendar/list").then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          // this.list = data.resData;
          _this.schoolYear = data.resData.schoolYear;
          _this.semester = data.resData.semester;
          _this.starttime = data.resData.starttime;
          _this.endtime = data.resData.endtime;
          _this.month = data.resData.month;
          _this.showText = data.resData.show;
          _this.list = data.resData.data;
          _this.serveId = data.resData.serveId;
          _this.checkBox = [];
          _this.items = null; // 如果默认当前月份没设置校历的时候，处理默认月份

          if (!_this.monthList) {
            var arr = [];
            var myData = new Date();
            var month = myData.getMonth() < 10 ? "0" + (myData.getMonth() + 1) : myData.getMonth() + 1;
            _this.month = myData.getFullYear() + "-" + month;
            _this.schoolYear = myData.getFullYear();
            arr.push({
              label: month + "月",
              value: _this.month
            });
            _this.monthList = arr;
          }
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 是否教学周
    isWeek: function isWeek(str) {
      if (typeof str == "string" && str.indexOf("not") > -1) {
        return "-";
      } else {
        return str;
      }
    },
    itemClass: function itemClass(val, key) {
      var str = " "; // 字体颜色

      if (!val.month) {
        str += "grey ";
      } else {
        if (!val.jobDate) {
          str += "grey ";
        } else {
          if (key == 5 || key == 6) {
            str += "red ";
          }
        }
      } // 背景色
      // if (!val.jobDate) {
      //   str += "bg-g ";
      // }


      if (val.isvacation == "1") {
        str += "bg-red ";
      } else if (val.isvacation == "2") {
        str += "bg-g ";
      }

      return str;
    },
    gotoCalendar: function gotoCalendar() {
      this.$router.push("serveSearch/".concat(this.serveId, "/Calendar"));
    }
  },
  watch: {},
  filters: {
    workType: function workType(value) {
      switch (value) {
        case "1":
          return "休息日";

        case "2":
          return "上班日";

        default:
          return "正常";
      }
    }
  }
};